import { NoAccessError, SessionExpiredError } from 'dashboard/utils/errors';
import { PREVIOUS_AUTH_ERROR_KEY } from 'dashboard/constants';
import window from 'ember-window-mock';

export default function persistRebootError(error: unknown) {
  const errorTypes = [NoAccessError, SessionExpiredError];

  if (!(error instanceof Error)) {
    console.debug(`'error' must be an instance of Error:`, error);
    return;
  }

  if (!errorTypes.some((errorType) => error instanceof errorType)) {
    console.debug(
      `'error' must be an instance of ${errorTypes.map((type) => type.name).join(', ')}:`,
      error,
    );
    return;
  }

  /**
   * Stash specific errors so that the login page can show an appropriate
   * error message when the app reboots after session invalidation.
   */
  try {
    window.sessionStorage.setItem(PREVIOUS_AUTH_ERROR_KEY, error.toString());
  } catch (storageError) {
    console.error('Failed to access sessionStorage:', storageError);
  }
}
